import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useRef } from 'react';
import { ButtonClickedEvent, LinkClickedEvent, ScreenViewedEvent } from '../Events';
import { useAnalyticsEvents } from '../withAnalytics';
export const usePrivacySecurityAnalytics = () => {
  const fireEvent = useAnalyticsEvents();
  const screenRef = useRef({
    attributes: {}
  });
  const getCommonAttributes = () => _objectSpread({
    source: screenRef.current.name
  }, screenRef.current.attributes);
  const addScreenAttributes = function addScreenAttributes() {
    let attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    screenRef.current.attributes = _objectSpread(_objectSpread({}, screenRef.current.attributes), attributes);
  };
  const fireScreenEvent = function fireScreenEvent(screenName) {
    let attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    screenRef.current.name = screenName;
    addScreenAttributes(attributes);
    fireEvent({
      eventType: ScreenViewedEvent,
      actionSubjectId: screenName,
      attributes: getCommonAttributes()
    });
  };
  const fireButtonEvent = function fireButtonEvent(actionSubjectId) {
    let attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    fireEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId,
      attributes: _objectSpread(_objectSpread({}, getCommonAttributes()), attributes)
    });
  };
  const fireLinkEvent = function fireLinkEvent(actionSubjectId) {
    let attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    fireEvent({
      eventType: LinkClickedEvent,
      actionSubjectId,
      attributes: _objectSpread(_objectSpread({}, getCommonAttributes()), attributes)
    });
  };
  return {
    fireScreenEvent,
    fireButtonEvent,
    fireLinkEvent,
    addScreenAttributes
  };
};
export default usePrivacySecurityAnalytics;